module.exports = __webpack_public_path__ + "static/logo-dpr-fda1063506b90b8a83196b64c7edef21.png";